import { Route, Router } from "@angular/router";

import { checkIfLoggedInFn, pmoEntity } from "../../core/guards";
import { SubmenuComponent } from "../../shared/components";
import { PageMode } from "../../shared/constants/enums";
import { ContextualHelpEditorComponent } from "./contextual-help/contextual-help-editor/contextual-help-editor";
import { ContextualHelpListComponent } from "./contextual-help/contextual-help-list/contextual-help-list";
import { FaqQuestionsComponent } from "./faq-questions/faq-questions";
import { FaqsEditorComponent } from "./faqs/faqs-editor/faqs-editor";
import { FaqsListComponent } from "./faqs/faqs-list/faqs-list";
import { FaqsCategoryComponent } from "./faqs-category/faqs-category";
import { SmartTooltipsListComponent } from "./smart-tooltips/smart-tooltips-list/smart-tooltips-list";
import { SmartTooltipsListEditorComponent } from "./smart-tooltips/smart-tooltips-list-editor/smart-tooltips-list-editor";

export const ONLINE_HELP_ROUTES: Route[] = [
  {
    path: "help",
    canActivate: [checkIfLoggedInFn, pmoEntity],
    children: [
      {
        path: "",
        component: SubmenuComponent,
        data: {
          breadcrumb: "help.help",
          title: "help.help",
          onEntityChange: (router: Router) => router.navigateByUrl("console"),
        },
      },
      {
        path: "smart-tool-tips",
        children: [
          {
            path: "",
            component: SmartTooltipsListComponent,
            data: {
              breadcrumb: "breadcrumbs.smart-tool-tips.list",
              title: "breadcrumbs.smart-tool-tips.list",
            },
          },
          {
            path: "edit/:id",
            component: SmartTooltipsListEditorComponent,
            data: {
              breadcrumb: "breadcrumbs.smart-tool-tips.edit",
              title: "breadcrumbs.smart-tool-tips.edit",
              pageMode: PageMode.edit,
            },
          },
        ],
      },
      {
        path: "faqs-category",
        component: FaqsCategoryComponent,
        data: {
          breadcrumb: "breadcrumbs.faqs_category.list",
          title: "breadcrumbs.faqs_category.list",
        },
      },
      {
        path: "faqs",
        children: [
          {
            path: "",
            component: FaqsListComponent,
            data: {
              breadcrumb: "breadcrumbs.faqs.list",
              title: "breadcrumbs.faqs.list",
            },
          },
          {
            path: "create",
            component: FaqsEditorComponent,
            data: {
              breadcrumb: "breadcrumbs.faqs.new",
              title: "breadcrumbs.faqs.new",
              pageMode: PageMode.create,
            },
          },
          {
            path: "edit/:id",

            component: FaqsEditorComponent,
            data: {
              breadcrumb: "breadcrumbs.faqs.edit",
              title: "breadcrumbs.faqs.edit",
              pageMode: PageMode.edit,
            },
          },
        ],
      },
      {
        path: "faqs-search",
        component: FaqQuestionsComponent,
        data: {
          breadcrumb: "breadcrumbs.faqs.list",
          title: "breadcrumbs.faqs.list",
        },
      },
      {
        path: "contextual-help",
        children: [
          {
            path: "",
            component: ContextualHelpListComponent,
            data: {
              breadcrumb: "breadcrumbs.contextual_help.list",
              title: "breadcrumbs.contextual_help.list",
            },
          },
          {
            path: "create",
            component: ContextualHelpEditorComponent,
            data: {
              breadcrumb: "breadcrumbs.contextual_help.add",
              title: "breadcrumbs.contextual_help.add",
              pageMode: PageMode.create,
            },
          },
          {
            path: "edit/:id",
            component: ContextualHelpEditorComponent,
            data: {
              breadcrumb: "breadcrumbs.contextual_help.edit",
              title: "breadcrumbs.contextual_help.edit",
              pageMode: PageMode.edit,
            },
          },
        ],
      },
    ],
  },
];
